<template>
    <template-layout fullheader="true">
        <template slot="header">
            <div class="container">
                <div class="hero-home">
                    <h1 class="title is-size-4-mobile">Elegí orgánicos</h1>
                    <h2 class="subtitle is-size-2-mobile">Tallo Verde</h2>

                    <p class="text">
                        El sabor y la frescura de alimentos orgánicos recién cosechados cautivarán a quienes los prueben.
                    </p>

                    <router-link class="button-buy button is-large is-primary" :to="{ name: 'Products' }">Comprar</router-link>
                </div>
            </div>

            <div class="quality">
                <div class="level is-mobile">
                    <div class="level-item is-marginless">
                        <img class="footer-logo" src="@/assets/img/logo-oia.png"/>
                    </div>

                    <div class="level-item is-marginless">
                        <img class="footer-logo" src="@/assets/img/logo-organico-argentina.png"/>
                    </div>
                </div>
            </div>

            <div class="social">
                <a href="https://www.facebook.com/talloverde/" target="_blank">
                    <span class="icon is-medium is-left"><i class="fab fa-lg fa-facebook-square"></i></span>
                </a>
                <a href="https://www.instagram.com/talloverde.organico" target="_blank">
                    <span class="icon is-medium is-left"><i class="fab fa-lg fa-instagram"></i></span>
                </a>
                <a href="https://wa.me/5491169085320" target="_blank">
                    <span class="icon is-medium is-left"><i class="fab fa-lg fa-whatsapp"></i></span>
                </a>
            </div>
        </template>

        <template slot="content">
            <section class="hero">
                <div class="hero-body">
                    <div class="container intro">
                        <div class="columns">
                            <div class="column sub-item">
                                <img src="@/assets/img/100fresco.png"/>
                                <span>
                                    Cosechamos las frutas y hortalizas el mismo día que el pedido llega a tu domicilio.
                                    Los alimentos orgánicos son naturalmente más duraderos, además, utilizamos vehículos
                                    acondicionados para preservar la calidad durante su traslado.
                                </span>
                            </div>
                            <div class="column sub-item">
                                <img src="@/assets/img/100rico.png"/>
                                <span>
                                    Descubrí el encanto original de los alimentos orgánicos: cultivados en suelos
                                    sustentables y libres de aditivos en todo el ciclo productivo, incluso desde la
                                    semilla. Las células compactas de cada producto mantienen intactos su aroma y sabor.
                                </span>
                            </div>
                            <div class="column sub-item">
                                <img src="@/assets/img/100saludable.png"/>
                                <span>
                                    Enriquecé tu alimentación con las propiedades y  los nutrientes completos de cada
                                    producto. Tu organismo comenzará a olvidarse de las alergias y problemas digestivos
                                    que derivan de los agregados artificiales, usuales en producciones convencionales.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="categories odd">
                <div class="container">
                    <home-product-categories></home-product-categories>
                </div>
            </section>

            <!-- <section class="recommended">
                <div class="container">
                    <home-recommended-products></home-recommended-products>
                </div>
            </section> -->
        </template>
    </template-layout>
</template>

<script>
    import TemplateLayout from "../../layout/TemplateLayout";
    import HomeProductCategories from "./HomeProductCategories";
    // import HomeRecommendedProducts from "./HomeRecommendedProducts";

    export default {
        name: 'home',
        data() {
            return {}
        },
        components: {
            // HomeRecommendedProducts,
            HomeProductCategories,
            TemplateLayout
        },

        mounted() {

        }
    }
</script>

<style lang="scss">
    .template-layout {
        > .header {
            background-image: url('./../../assets/img/homepage-2.jpg');
            background-position: center;
            background-size: cover;
        }
    }
</style>

<style lang="scss" scoped>
    @import "@/assets/css/home.scss";

    .button-buy {
        font-size: 2.0rem;
    }
</style>